<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.width < 400"
  >
    <v-toolbar max-height="64">
      <v-toolbar-title>
        {{ $t("2fa.codeRequired") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text
      class="d-flex align-center justify-center px-5 flex-column white"
      style="height: 100%"
    >
      <p
        class="black--text justify-self-start body-2 "
        :class="$vuetify.breakpoint.mobile ? '' : 'px-12'"
      >
        {{ $t("2fa.otpSent") }}
      </p>
      <v-form @submit="submitOtp">
        <v-otp-input
          ref="otpInput"
          :input-classes="
            $vuetify.breakpoint.width < 400
              ? 'otp-input otp-small'
              : 'otp-input'
          "
          separator=""
          :num-inputs="6"
          :should-auto-focus="true"
          :is-input-num="true"
          @on-change="handleOnChange"
        />
        <v-card-actions class="mt-6">
          <v-btn
            small
            style="width: 50%"
            type="submit"
            @click.prevent="resendOtp"
            :color="disableResendOtp ? 'grey' : 'secondary'"
            :loading="loadings.resendOtp"
            :class="{
              'disable-submit-otp': disableResendOtp,
            }"
          >
            <template v-slot:loader>
              <div class="mr-3">
                {{ $t("2fa.resending") }}
              </div>
              <v-progress-circular
                indeterminate
                size="18"
                width="2"
              ></v-progress-circular>
            </template>
            {{
              countdowns.resend.timer === 0
                ? $t("2fa.resendCode")
                : $t("2fa.resendCodeShort", {
                    seconds: countdowns.resend.timer,
                  })
            }}
          </v-btn>
          <v-btn
            small
            style="width: 50%"
            type="submit"
            @click.prevent="submitOtp"
            :color="disableSubmitOtp ? 'grey' : 'primary'"
            :loading="loadings.submitOtp"
            :class="{
              'disable-submit-otp': disableSubmitOtp,
            }"
          >
            <template v-slot:loader>
              <div class="mr-3">
                {{ $t("2fa.verifying") }}
              </div>
              <v-progress-circular
                indeterminate
                size="18"
                width="2"
              ></v-progress-circular>
            </template>
            {{ $t("2fa.verify") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "loadings"],

  data: () => ({
    currentOtpToken: "",
    countdowns: {
      resend: {
        timer: 60,
        intervalId: 0,
      },
    },
  }),

  created() {
    if (this.countdowns.resend.intervalId === 0) {
      this.countdowns.resend.intervalId = setInterval(() => {
        this.countdowns.resend.timer--;
      }, 1000);
    }

    this.focusFirstOtpNumber();
  },

  computed: {
    disableSubmitOtp() {
      return !this.currentOtpToken || this.currentOtpToken.length !== 6;
    },

    disableResendOtp() {
      return this.countdowns.resend.timer !== 0;
    },
  },

  watch: {
    dialog() {
      clearInterval(this.countdowns.resend.intervalId);

      this.countdowns.resend.timer = 60;
      this.countdowns.resend.intervalId = setInterval(() => {
        this.countdowns.resend.timer--;
      }, 1000);

      this.focusFirstOtpNumber();
    },

    "countdowns.resend.timer"(val) {
      if (val === 0) {
        clearInterval(this.countdowns.resend.intervalId);
      }
    },
  },

  methods: {
    submitOtp() {
      if (this.currentOtpToken.length === 6) {
        this.$emit("doLogin", {
          token: this.currentOtpToken,
          type: "submitOtp",
        });
      }
    },

    resendOtp() {
      if (this.countdowns.resend.timer > 0) {
        return;
      }

      this.countdowns.resend.timer = 60;

      this.countdowns.resend.intervalId = setInterval(() => {
        this.countdowns.resend.timer--;
      }, 1000);

      this.$emit("doLogin", {
        type: "resendOtp",
      });
    },

    handleOnChange(val) {
      this.currentOtpToken = val;
    },

    focusFirstOtpNumber() {
      if (this.dialog) {
        setTimeout(() => {
          const firstDiv = this.$refs.otpInput.$children[0].$el;
          const firstInput = firstDiv.querySelector("input");
          firstInput.focus();
        }, 10);
      }
    },

    clearOtp() {
      this.$refs.otpInput.clearInput();
    },

    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style>
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

.otp-small {
  width: 30px;
  height: 30px;
  padding: 5px;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.disable-submit-otp {
  pointer-events: none;
  color: grey;
}
</style>
